import React, { Component } from 'react'
import Filter from '@/components/UserOperation/Filter'
import { Table } from 'antd'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import OperationAPI from '@/API/operation'
import dayjs from 'dayjs'

const OperationTable=styled(Table)`
  padding:20px;
  .ant-table-tbody td{
    word-break:break-all;
  }
`

class UserOperation extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      filter:{
        userName:'',
        time:[]
      },
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      userOperationList:[]
    }
  }
  componentDidMount(){
    this.getData()
  }
  filterChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      filter:{
        ...prevState.filter,
        ...field
      }
    }))
  }
  search=()=>{
    this.setState((prevState)=>({
      pagination:{
        ...prevState.pagination,
        current:1
      }
    }),()=>{
      this.getData()
    })
  }
  getData(){
    const {filter,pagination}=this.state
    const startTime=filter.time[0]?dayjs(filter.time[0]).startOf('day').unix():null
    const endTime=filter.time[1]?dayjs(filter.time[1]).endOf('day').unix():null
    OperationAPI.getUserRecords({
      userName:filter.userName,
      startTime:startTime,
      endTime:endTime,
      pageIndex:pagination.current-1,
      pageSize:pagination.pageSize
    }).then((res)=>{
      this.setState((prevState)=>({
        userOperationList:res.data,
        pagination:{
          ...prevState.pagination,
          total:res.totalCount
        }
      }))
    })
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getData()
    });
  }
  render() {
    const {pagination,userOperationList}=this.state
    const columns=[
      {
        title:'操作类型',
        width:120,
        dataIndex:'operateType'
      },
      {
        title:'操作时间',
        width:120,
        dataIndex:'operateTime',
        render:(text)=>(dayjs(text).format('YYYY-MM-DD HH:mm:ss'))
      },
      {
        title:'操作用户',
        width:120,
        dataIndex:'userName'
      },
      {
        title:'操作用户IP',
        width:100,
        dataIndex:'operateIp'
      },
      {
        title:'操作路径',
        width:150,
        dataIndex:'operatePath'
      },
      {
        title:'详细信息',
        width:450,
        dataIndex:'info'
      }
    ]
    return (
      <div>
        <Filter filterChange={this.filterChange} search={this.search}></Filter>
        <OperationTable columns={columns} dataSource={userOperationList} rowKey="id" pagination={pagination} onChange={this.handleTableChange}></OperationTable>
      </div>
    )
  }
}

export default withTranslation()(UserOperation);